module.exports = __webpack_public_path__ + "static/media/logo_light.c53cbec8.png";